module.exports = __webpack_public_path__ + "static/img/04_display.dbdd067.png";